import { navigate } from 'wouter/use-browser-location';
import { ApplicationFooter } from '../../application/ApplicationBackground';
import { ROUTES } from '../../routes/consts';
import { Modal } from '@platform/components';
import { useState } from 'react';

export const ChallengeFormBackground = ({
  onSubmit,
  onBack,
  onContinue,
  backgroundImage,
  children,
}: {
  onSubmit: () => void;
  onBack: () => void;
  onContinue: () => void;
  backgroundImage: string;
  children: React.ReactNode;
}) => {
  // TODO: add basic modal notification?
  const [isSaveExitModalOpen, setIsSaveExitModalOpen] = useState(false);
  const handleSaveExit = () => {
    onSubmit();
    navigate(`platform${ROUTES.DASHBOARD}`);
  };
  const handleSubmit = () => {
    onSubmit();
    onContinue();
  };
  return (
    <form
      className='w-full h-[100vh] md:max-h-[100vh] flex flex-col overflow-y-auto md:overflow-y-auto'
      onSubmit={handleSubmit}
    >
      <div className='w-full flex flex-row h-full md:h-[100vh]'>
        <div className='hidden h-full md:block w-1/2 bg-gray-50'>
          <div
            className='hidden h-full w-full md:flex justify-start items-start'
            style={{
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundColor: 'white',
            }}
          />
        </div>
        <div className='w-full h-full md:w-1/2 md:px-8 md:py-4 flex justify-center overflow-y-scroll '>
          {children}
        </div>
      </div>
      <ApplicationFooter
        onBack={onBack}
        openSaveAndExitModal={() => setIsSaveExitModalOpen(true)}
      />
      <SaveAndExitModal
        isOpen={isSaveExitModalOpen}
        onClose={() => setIsSaveExitModalOpen(false)}
        onSave={handleSaveExit}
      />
    </form>
  );
};

const SaveAndExitModal = ({
  onClose,
  onSave,
  isOpen,
}: {
  onClose: () => void;
  onSave: () => void;
  isOpen: boolean;
}) => {
  return (
    <Modal
      variant='dialog'
      title='Save business challenge changes'
      isOpen={isOpen}
      headerDivision='divider'
      onClose={onClose}
      ignoreExtraPadding={true}
      primaryCTA={{
        text: 'Update challenges',
        callback: onSave,
      }}
      secondaryCTA={{
        text: 'Continue editing',
        callback: onClose,
      }}
    >
      <div className='flex flex-col gap-4 w-full text-center h-full'>
        <div>Select update challenges to save your changes and return to the dashboard</div>
      </div>
    </Modal>
  );
};
